import React from 'react'

const CompanyFiles = () => {
  return (
    <div>CompanyFiles</div>
  )
}

export default CompanyFiles